import React from "react";

import { Header, Item } from "semantic-ui-react";

import PendingReimbursementItem from "../../../components/PendingReimbursementItem";
import ReimbursementTable from "../../../components/ReimbursementTable";

import {
  hasCapability,
  APPROVE_REIMBURSEMENTS
} from "../../../util/capability";

import _ from "lodash";

import * as moment from "moment";

const sortReimbursementList = reimbursements =>
  _.sortBy(reimbursements, r => -+moment(r.last_action_at));

const AllReimbursementsView = props => {
  const pendingReimbursements = sortReimbursementList(
    props.pendingReimbursements
  );

  const tableReimbursements = sortReimbursementList(
    hasCapability(APPROVE_REIMBURSEMENTS)
      ? props.resolvedReimbursements
      : props.reimbursements
  );

  return (
    <div>
      {hasCapability(APPROVE_REIMBURSEMENTS) && (
        <div>
          <Header dividing as="h3">
            <Header.Content>
              Reimbursements that need your review
              <Header.Subheader>
                Click on the reimbursement to see more.
              </Header.Subheader>
            </Header.Content>
          </Header>
          <Item.Group>
            {pendingReimbursements.length === 0 && (
              <span>Hooray! You have no reimbursements to review.</span>
            )}
            {pendingReimbursements.map((reimbursement, i) => (
              <PendingReimbursementItem
                reimbursement={reimbursement}
                key={reimbursement.uuid}
              />
            ))}
          </Item.Group>
        </div>
      )}
      <Header dividing as="h3">
        <Header.Content>
          {hasCapability(APPROVE_REIMBURSEMENTS)
            ? "Resolved reimbursements"
            : "All reimbursements"}
          <Header.Subheader>Click on a row to see more.</Header.Subheader>
        </Header.Content>
      </Header>
      <ReimbursementTable reimbursements={tableReimbursements} />
    </div>
  );
};

export default AllReimbursementsView;



// WEBPACK FOOTER //
// ./frontend/src/views/pages/reimbursements/AllReimbursementsView.js